import actions from './actions';

const initState = {
  productos: [],
  initialProductos: false,
  currentProducto: null,
  editableProducto: {},
  loadingProductos: false,
  loadingOpcionales: false,
  dataLoaded:false,
  opcionales:[]
};

export default function productoReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_PRODUCTOS: {
      return {
        ...state,
        loadingProductos: true,
      }
    }
    case actions.GET_OPCIONALES: {
      return {
        ...state,
        loadingOpcionales: true,
      }
    }
    case actions.UPDATE_PRODUCTOS: {
      return {
        ...state,
        productos: action.productos,
        initialProductos: true,
        loadingProductos: false,
        dataLoaded: true,
      };
    }
    case actions.UPDATE_OPCIONALES: {
      return {
        ...state,
        opcionales: action.opcionales,
        loadingOpcionales: false,
        dataLoaded: true,
      };
    }
    case actions.EDIT_PRODUCTO:
    case actions.DELETE_PRODUCTO:
    case actions.CREATE_PRODUCTO:{
      return {
        ...state,
        dataLoaded: false,
      };
    }
    default:
      return state;
  }
}
